<template>
  <div class="topic">
    <div style="margin-bottom: 20px">
      <el-button size="small" @click="addTab(editableTabsValue)">
        添加题目（单选）
      </el-button>
    </div>
    <el-tabs
      v-model="editableTabsValue"
      type="card"
      closable
      @tab-remove="removeTab"
    >
      <el-tab-pane
        v-for="(item, index) in editableTabs"
        :key="item.name"
        :label="item.title"
        :name="item.name"
      >
        <MyForm
          ref="resultdemoRef"
          :types="type"
          :id="testid"
          :list="Tmobject[index]"
          :result_type="result_type"
          v-if="isLoaded"
          :getData="copyxuanxiang"
          :resultsList="resultsList"
        />
        <!--   -->
      </el-tab-pane>
    </el-tabs>
    <div class="submitbtn">
      <el-button type="primary" @click="onSubmit">保存全部题目</el-button>
      <el-button @click="copyxuanxiang">复制选项</el-button>
    </div>
  </div>
</template>

<script>
import MyForm from "@/components/topic_form.vue";
import { saveTestQuestion, getTestQuestion } from "@/api/coupon";
export default {
  data() {
    return {
      editableTabsValue: "1",
      editableTabs: [
        {
          title: "题目1",
          name: "1",
          content: "Tab 1 content",
        },
      ],
      tabIndex: 2,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      type: 0,
      testid: 0,
      Tmobject: [],
      result_type: 0,
      isLoaded: false,
      resultsList:[]
    };
  },
  created() {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.slice(hash.indexOf("?") + 1));
    this.testid = params.get("id");
    this.type = params.get("type");
    this.result_type = params.get("result_type");
    console.log(this.testid, this.type, this.result_type);

    this.getTestQuestionHandel();
  },
  mounted() {
    console.log(this.Tmobject);
  },
  computed: {
    isDataReady() {
      return this.Tmobject.length > 0;
    },
  },
  components: {
    MyForm,
  },
  methods: {
    copyxuanxiang(){
      var formValues = [];
      this.editableTabs.forEach((item, index) => {
        const resultdemoRef = this.$refs["resultdemoRef"][index];
        const formData = resultdemoRef.submitForm();
        formValues.push(formData);
      });
      const promises = [...formValues];
      const objects = promises.map((promise) => {
        return promise.then((result) => {
          return result;
        });
      });

      Promise.all(objects)
        .then((results) => {
          console.log("原始", results);
           
            let formValues;
          if (results.some((obj) => !obj.hasOwnProperty("index"))) {
            const dataWithIndex = results.map((obj, index) => {
              return {
                ...obj,
                index: obj.hasOwnProperty("index") ? obj.index : index + 1,
              };
            });

            console.log("dataWithIndex排序前", dataWithIndex);
            formValues = dataWithIndex.sort((a, b) => a.index - b.index);
            console.log("dataWithIndex排序后", formValues);
            this.resultsList = formValues
          } else {
            console.log("原始", results);
            formValues = results.sort((a, b) => a.index - b.index);
            console.log("results11", formValues)
            this.resultsList = formValues
          }
        })
        .catch((error) => {});
    },
    addTab(targetName) {
      let newTabName = this.editableTabs.length + 1 + "";
      console.log(newTabName, this.editableTabs);
      this.editableTabs.push({
        title: "题目" + Number(this.editableTabs.length + 1),
        name: newTabName,
        content: "New Tab content",
      });
      this.editableTabsValue = newTabName;
    },
    removeTab(targetName) {
      this.$confirm("此操作将会删除该题目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(targetName, this.editableTabs);
          let tabs = this.editableTabs;
          let activeName = this.editableTabsValue;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }

          this.editableTabsValue = activeName;
          this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onSubmit() {
      var formValues = [];
      this.editableTabs.forEach((item, index) => {
        const resultdemoRef = this.$refs["resultdemoRef"][index];
        const formData = resultdemoRef.submitForm();
        formValues.push(formData);
      });
      const promises = [...formValues];
      const objects = promises.map((promise) => {
        return promise.then((result) => {
          return result;
        });
      });

      Promise.all(objects)
        .then((results) => {
          console.log("原始", results);
          // const dataWithIndex = results.map((obj, index) => {
          //   return { ...obj, index: index + 1 };
          // });
          // console.log('dataWithIndex排序前',dataWithIndex);
          // formValues = dataWithIndex.sort((a, b) => a.index - b.index);
          // console.log("dataWithIndex排序后", formValues);
          // formValues = JSON.stringify(formValues);
          // console.log("results11", formValues);
          let formValues;
          if (results.some((obj) => !obj.hasOwnProperty("index"))) {
            const dataWithIndex = results.map((obj, index) => {
              return {
                ...obj,
                index: obj.hasOwnProperty("index") ? obj.index : index + 1,
              };
            });

            console.log("dataWithIndex排序前", dataWithIndex);
            formValues = dataWithIndex.sort((a, b) => a.index - b.index);
            console.log("dataWithIndex排序后", formValues);
            formValues = JSON.stringify(formValues);
          } else {
            console.log("原始", results);
            formValues = results.sort((a, b) => a.index - b.index);
            console.log("results11", formValues);
            formValues = JSON.stringify(results);
            
          }
          let data = {
            test_id: this.testid,
            question_list: formValues,
          };
          saveTestQuestion(data).then((res) => {
            console.log(res);
            if (res.code == 1) {
              if (this.result_type != 3) {
                this.$message({
                  message: "恭喜你，保存成功",
                  type: "success",
                });
                this.$router.push(
                  "/appraisal/result" +
                    "?id=" +
                    this.testid +
                    "&type=" +
                    this.type
                );
              } else {
                this.$message({
                  message: "恭喜你，保存成功",
                  type: "success",
                });
                this.$router.push("/appraisal/list");
              }
            }
          });
        })
        .catch((error) => {});
    },
    getTestQuestionHandel() {
      let data = {
        test_id: this.testid,
      };
      getTestQuestion(data).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.Tmobject = res.data;
          this.handleLoadingComplete();
          let arrLength = this.Tmobject.length - 1;
          var generatedTabs = [];
          for (let i = 0; i < arrLength; i++) {
            this.editableTabs.push({
              title: `题目${i + 2}`,
              name: `${i + 2}`,
              content: `Tab ${i + 2} content`,
            });
          }
          console.log(this.editableTabs);
        } else {
          this.handleLoadingComplete();
        }
      });
    },
    handleLoadingComplete() {
      // 根据你的实际情况进行判断，如果所有接口都加载完毕，将isLoaded设置为true
      this.isLoaded = true;
    },
  },
};
</script>

<style>
.submitbtn {
  margin-left: 200px;
  margin-top: 60px;
}
</style>